import ReactGA from 'react-ga';

ReactGA.initialize(process.env.REACT_APP_GA_ID);
ReactGA.set({
    anonymizeIp: true
});

export default ReactGA;